import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=1bc5801c&"
import script from "./Bill.vue?vue&type=script&lang=ts&"
export * from "./Bill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports